module.exports = __webpack_public_path__ + "img/Truce_Logo_Orange_Stripe.0fcdc8f5.png";